"use client";

import Image from "next/image";
import Link from "next/link";

const gamesList1 = [
  {
    title: "Super Ace",
    img: "/assets/dalal1.png",
  },
  {
    title: "Super Rich",
    img: "/assets/dalal2.png",
  },
  {
    title: "Sweet Land",
    img: "/assets/dalal3.jpg",
  },
  {
    title: "The Pig House",
    img: "/assets/dalal4.jpg",
  },
  {
    title: "Thor X",
    img: "/assets/dalal5.png",
  },
  {
    title: "Treasure Quest",
    img: "/assets/dalal6.png",
  },
  // {
  //   title: "Trial Of Phoenix",
  //   img: "/assets/image.png",
  // },
  // {
  //   title: "Twin Wins",
  //   img: "/assets/image1.png",
  // },
];

// const gamesList2 = [
//   {
//     title: "Wild Ace",
//     img: "https://www.baghaffiliates.xyz/games/wildace.png",
//   },
//   {
//     title: "Wild Racer",
//     img: "https://www.baghaffiliates.xyz/games/wildracer.png",
//   },
//   {
//     title: "Win Drop",
//     img: "https://www.baghaffiliates.xyz/games/windrop.png",
//   },
//   {
//     title: "Witches Night",
//     img: "https://www.baghaffiliates.xyz/games/witchesnight.png",
//   },
//   {
//     title: "World Cup",
//     img: "https://www.baghaffiliates.xyz/games/worldcup.png",
//   },
//   {
//     title: "Xiyangyang",
//     img: "https://www.baghaffiliates.xyz/games/xiyangyang.png",
//   },
//   {
//     title: "Zeus",
//     img: "https://www.baghaffiliates.xyz/games/zeus.png",
//   },
//   {
//     title: "Jili Caishen",
//     img: "https://www.baghaffiliates.xyz/games/jilicaishen.png",
//   },
// ];

const ProductsSection = () => {
  return (
    <section className="h-164 lg:h-232.25 flex items-center bg-bg9 overflow-visible">
      <div className="container text-white">
        <p className="section-title text-center text-white! max-lg:max-w-[374px] max-lg:mx-auto max-lg:leading-[15px]">
          Products
        </p>

        <h2 className="text-center text-3xl lg:text-[40px] mb-4 mt-10 max-lg:my-5 max-lg:max-w-[374px] max-lg:mx-auto">
          Products of DALAL
        </h2>

        <p className="text-xs lg:text-sm max-w-227.5 w-full mx-auto text-center">
          Step into Dalal's gaming jungle &mdash; where over{" "}
          <strong>5,000 thrilling games</strong> grow like wild fruit! Players
          leap from trending slots to live dealer vines and sports betting
          trails, giving you endless ways to attract every type of gamer. With
          fresh game drops sprouting weekly and ready-made promo paths for each
          player personality, recruiting new fans becomes as easy as following a
          jungle river to water!
        </p>

        <div className="mt-15 flex gap-5 lg:gap-5.5 overflow-auto lg:overflow-hidden">
          {gamesList1?.map((game, index) => (
            <div
              key={index}
              className="rounded-2xl w-28.75 lg:w-37.5 h-37.5 lg:h-49.75 overflow-hidden shrink-0 relative group"
              title={game.title}
            >
              <Image
                src="/assets/favicon.png"
                alt="logo"
                width={30}
                height={30}
                className="absolute top-1 right-2 z-10"
              />
              <Image
                alt={game.title}
                width={150}
                height={199}
                className="object-cover size-full"
                src={game.img}
              />

              <div className="flex flex-col items-center justify-center gap-4 size-full bg-black/35 absolute top-0 left-0 group-hover:opacity-100 opacity-0 transition-all duration-300">
                <h3 className="line-clamp-1 text-center capitalize font-extrabold text-lg w-30 mx-auto">
                  {game.title}
                </h3>
                <Link
                  rel="noopener noreferrer"
                  target="_blank"
                  className="bg-bg10 h-9 rounded-full uppercase py-2 text-sm font-extrabold px-5"
                  href={process.env.NEXT_PUBLIC_API_URL || "#"}
                >
                  Play Now
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 flex gap-5 lg:gap-5.5 overflow-auto lg:overflow-hidden">
          {/* {gamesList2?.map((game, index) => (
            <div
              key={index}
              className="rounded-2xl w-28.75 lg:w-37.5 h-37.5 lg:h-49.75 overflow-hidden shrink-0 relative group"
              title={game.title}
            >
              <Image
                alt={game.title}
                width={150}
                height={199}
                className="object-cover size-full"
                src={game.img}
              />

              <div className="flex flex-col items-center justify-center gap-4 size-full bg-black/35 absolute top-0 left-0 group-hover:opacity-100 opacity-0 transition-all duration-300">
                <h3 className="line-clamp-1 text-center capitalize font-extrabold text-lg w-30 mx-auto">
                  {game.title}
                </h3>
                <Link
                  rel="noopener noreferrer"
                  target="_blank"
                  className="bg-bg10 h-9 rounded-full uppercase py-2 text-sm font-extrabold px-5"
                  href="https://staging.dalal.live/"
                >
                  Play Now
                </Link>
              </div>
            </div>
          ))} */}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
